export enum LayoutResourceLibraryMain {
    GRID,
    LIST
}